import NameProcess from "./PieChartComponent/NameProcess";
import StepProcess from "./PieChartComponent/StepProcess";
import RunMethodProcess from "./PieChartComponent/RunMethodProcess";
import StatusProcess from "./PieChartComponent/StatusProcess";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { getFilteredSummary } from "../../../../../utils/helpers";
import { useDispatch } from "react-redux";
import { setIsFilterAnyLogs } from "../../../../../features/monitoringProcessLogsSlice";

const ProcessLogsPieChart = () => {
  const {
    processLogsSummeryData,
    isFilterAnyLogs,
    selectedWorkFlow,
    selectedLogsPackage,
    selectedLogsProcessName,
    selectedLogsStatus,
    selectedLogsBrand,
    selectedLogsInterface,
    selectedRunMethodList,
    selectedStepList,
  } = useSelector((state: any) => state.monitoringProcessLogs);
  const dispatch = useDispatch();

  // //--- By default Get process logs summery name, step, status, and run method data
  const processByName = useMemo(
    () => getFilteredSummary(processLogsSummeryData?.summary_by_process_name),
    [processLogsSummeryData?.summary_by_process_name]
  );

  const summeryByStep = useMemo(
    () => getFilteredSummary(processLogsSummeryData?.summary_by_step),
    [processLogsSummeryData?.summary_by_step]
  );

  const processByStatus = useMemo(
    () => getFilteredSummary(processLogsSummeryData?.summary_by_status),
    [processLogsSummeryData?.summary_by_status]
  );

  const processByRunMethod = useMemo(
    () => getFilteredSummary(processLogsSummeryData?.summary_by_execution_type),
    [processLogsSummeryData?.summary_by_execution_type]
  );

  //-- Check if any of filter item selected then set isFilterAnyLogs to true, otherwise false (Its only for summery by step data)
  useEffect(() => {
    const isAnyFilterSelected =
      selectedWorkFlow?.length > 0 ||
      selectedLogsPackage?.length > 0 ||
      selectedLogsProcessName?.length > 0 ||
      selectedLogsStatus?.length > 0 ||
      selectedLogsBrand?.length > 0 ||
      selectedLogsInterface?.length > 0 ||
      selectedRunMethodList?.length > 0 ||
      selectedStepList?.length > 0;

    // This condition prevents dispatching if the value hasn't actually changed.
    if (isFilterAnyLogs !== isAnyFilterSelected) {
      dispatch(setIsFilterAnyLogs(isAnyFilterSelected));
    }
    // eslint-disable-next-line
  }, [
    selectedWorkFlow,
    selectedLogsPackage,
    selectedLogsProcessName,
    selectedLogsStatus,
    selectedLogsBrand,
    selectedLogsInterface,
    selectedRunMethodList,
    selectedStepList,
  ]);

  return (
    <Grid container spacing={2} mt={2} pb={2} width={"100%"} alignItems="stretch">
      <Grid item xs={12} sm={12} md={6} xl={3}>
        <NameProcess data={processByName} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} xl={3}>
        <StepProcess data={summeryByStep} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} xl={3}>
        <StatusProcess data={processByStatus} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} xl={3}>
        <RunMethodProcess data={processByRunMethod} />
      </Grid>
    </Grid>
  );
};

export default ProcessLogsPieChart;
